<template>
  <section>
    <SideBar
      @closeSideBar="toggleSideBar"
      v-if="sideBarOpen"
      :links="content.home.navigation"
      data-aos="fade-right"
    />
    <NavBar
      @toggleSideBar="toggleSideBar"
      :sideBarOpen="sideBarOpen"
      :links="content.home.navigation"
      backgroundColor="white"
      :is-home-page="false"
      textColor="orange"
      :logo="
        $isMobile()
          ? require('../assets/images/house-orange.png')
          : require(`../assets/images/logo-orange.png`)
      "
      data-aos="fade-down"
    />
    <div class="terms">
      <div class="terms__section" data-aos="fade-up">
        <h3 class="terms__section--title">{{ content.terms.title_1 }}</h3>
        <div class="terms__section--body">
          <p v-for="(body, i) in content.terms.body_1" :key="`body_1_${i}`">
            {{ body }}
          </p>
        </div>
      </div>
      <div class="terms__section" data-aos="fade-up">
        <h3 class="terms__section--title">{{ content.terms.title_2 }}</h3>
        <div class="terms__section--body">
          <p v-for="(body, i) in content.terms.body_2" :key="`body_2_${i}`">
            {{ body }}
          </p>
        </div>
      </div>
    </div>
    <div class="footer">
      <p class="footer__body">
        {{ content.home.footer.body_1
        }}<a
          class="footer__body--link"
          :href="`mailto:${content.home.footer.link_1}`"
          target="_blank"
          >{{ content.home.footer.link_1 }}</a
        >{{ content.home.footer.body_2 }}
      </p>
      <p class="footer__body">
        {{ content.home.footer.body_3
        }}<a
          class="footer__body--link"
          :href="content.home.footer.url"
          target="_blank"
          >{{ content.home.footer.link_2 }}</a
        >
      </p>
    </div>
  </section>
</template>

<script>
import Content from '../data/content'
import NavBar from '../components/NavBar'
import SideBar from '../components/SideBar'

export default {
  name: 'Terms',
  components: {
    NavBar,
    SideBar,
  },
  data() {
    return {
      content: Content,
      sideBarOpen: false,
    }
  },
  methods: {
    toggleSideBar(val) {
      this.sideBarOpen = val
    },
  },
}
</script>

<style lang="scss">
.terms {
  background-color: var(--color-mozzarella-2);
  padding: 5% 10% 10%;
  &__section {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    &--title {
      width: 30%;
    }
    &--body {
      width: 60%;
    }
  }
}
</style>